import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-10 px-4" data-id="element-56">
      <div className="max-w-2xl mx-auto text-center" data-id="element-57">
        <div className="border-4 border-dashed border-gray-300 rounded-xl p-6 md:p-8" data-id="element-58">
          <ShieldCheck className="w-12 h-12 text-green-500 mx-auto mb-3" data-id="element-59" />

          <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-3 font-['Oswald'] uppercase" data-id="element-60">
            🛡️ Garantía de 7 días
          </h2>

          <p className="text-base text-gray-700 mb-2" data-id="element-61">
            Si no ves a tu hijo más interesado en aprender…
          </p>
          <p className="text-lg font-bold text-gray-900 mb-2" data-id="element-62">
            👉 Tienes 7 días para solicitar devolución.
          </p>
          <p className="text-sm text-gray-500" data-id="element-63">Sin preguntas.</p>
        </div>
      </div>
    </section>;
}